/** Compact relative timestamp for dashboard rows ("3m ago", "never"). */
export function timeAgo(iso?: string | null): string {
  if (!iso) return "never";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return `${Math.floor(s)}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

/** Compact count for token totals ("982", "12.4k", "1.2M"). */
export function compactCount(n: number): string {
  if (!Number.isFinite(n) || n <= 0) return "0";
  const one = (v: number) => {
    const s = v.toFixed(1);
    return s.endsWith(".0") ? s.slice(0, -2) : s;
  };
  if (n < 1000) return String(Math.floor(n));
  if (n < 1_000_000) return `${one(n / 1000)}k`;
  return `${one(n / 1_000_000)}M`;
}

/** "12.4k in / 3.1k out" for sessions reporting token usage (phase 5) —
 *  null when the session (or an older plane) has no counters yet. */
export function tokenSummary(s: {
  inputTokens?: number;
  outputTokens?: number;
}): string | null {
  const input = s.inputTokens ?? 0;
  const output = s.outputTokens ?? 0;
  if (input <= 0 && output <= 0) return null;
  return `${compactCount(input)} in / ${compactCount(output)} out`;
}
